import { svc_search, svc_addOne, svc_editOne, svc_fetchAll, svc_deleteOne } from "@/services";
import { message } from "antd";
import { showServerResponse } from "@/utils/message";
import "lodash";
import logger from "@/utils/logger";

const endpointBasePrefix = "pos_language";

const Model = {
	namespace: "m_PosLanguage",
	state: {
		poslanguage: [],
		policy: [],
		scopeToken: {},
	},
	reducers: {
		handleFetchAll(state, { payload: { poslanguage } }) {
			logger(`** PosLanguage reducers response ${JSON.stringify(poslanguage)}`, 5);
			return { ...state, poslanguage };
		}
	},
	effects: {
		*fetchAll({ brandId, outletId, scopeToken }, { call, put }) {
			// console.log("*********************** brandId: ", brandId)
			// console.log("*********************** outletId: ", outletId)
			// console.log("Checking against scope ", scopeToken);

			let poslanguage = yield call(svc_search, endpointBasePrefix, { brand: brandId, outlet: outletId });
			// let poslanguage = yield call(svc_fetchAll, `${endpointBasePrefix}/${brandId}/${outletId}`);
			_.forEach(poslanguage, function (row) {

				// row.key = row.id;
				if (outletId && !scopeToken.allowedDerivedOutlets.includes(outletId)) row.disableEdit = true;
				if (brandId && !outletId && !scopeToken.allowedBrands.includes(brandId)) row.disableEdit = true;
			});
			// console.log("*********************** poslanguage: ", poslanguage)
			yield put({
				type: "handleFetchAll",
				payload: { poslanguage },
			});
		},
		*addOne({ payload }, { call, put }) {
			let newPOSLanguage = yield call(svc_addOne, endpointBasePrefix, payload);
			logger(("Created POS Language: ", JSON.stringify(newPOSLanguage)), 5);
			message.success("POS Language created.");
		},
		*editOne({ payload }, { call, put }) {
			let newPOSLanguage = yield call(svc_editOne, endpointBasePrefix, payload, "id");
			logger(("Edited POS Language: ", JSON.stringify(newPOSLanguage)), 5);
			message.success("POS Language edited.");
		},
		*deleteOne({ payload }, { call, put }) {
			const response = yield call(
				svc_deleteOne,
				endpointBasePrefix,
				payload,
				"id",
				payload.key,
			);
			return showServerResponse(response);
		},
	},
	subscriptions: {
		setup({ dispatch, history }) {
			return history.listen(({ pathname, query }) => {
				if (pathname === "/payment") {
					dispatch({ type: "fetch", payload: query });
				}
			});
		},
	},
};

export default Model;
